import { Modal } from 'bootstrap';
import Validation from '@/js/components/forms/validation';
import createCookie from '@/js/components/cookies/createCookie';

const popups = document.getElementById('newsletter-modal');
const formSubscriber = document.getElementById('newsletter-form');
const disableOnThisPage = document.getElementById('newsletter-subscribe');
const infoPopup = document.getElementById('info-modal');

function checkCookie(name) {
  const cookies = document.cookie.split(';');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(`${name}=`)) {
      return true;
    }
  }
  return false;
}

function closeModalWithDelay(modal, delay) {
  setTimeout(() => {
    modal.hide();
  }, delay);
}

function showNewsletterModal() {
  if (!disableOnThisPage && popups && !checkCookie('newsletterModalClosed')) {
    const newsletterModal = new Modal(popups, {
      backdrop: 'static',
    });

    popups.addEventListener('hidden.bs.modal', () => {
      createCookie('newsletterModalClosed', 'true', 30);
    });

    newsletterModal.show();

    if (formSubscriber) {
      // eslint-disable-next-line no-unused-vars
      const subscriberFormValidation = new Validation(formSubscriber);

      document.addEventListener('formSuccess', () => {
        const delay = 2000;
        closeModalWithDelay(newsletterModal, delay);
      });
    }
  }
}

if (infoPopup && !checkCookie('infoModalClosed')) {
  const infoModal = new Modal(infoPopup, {
    backdrop: 'static',
  });

  infoPopup.addEventListener('hidden.bs.modal', () => {
    createCookie('infoModalClosed', 'true', 30);
    showNewsletterModal(); // Show newsletter modal *after* info modal closes
  });

  infoModal.show();
} else {
  // If no info modal, or already shown before, go directly to newsletter
  showNewsletterModal();
}
